import React from 'react';
import { mockData } from '../mock';
import { CheckCircle } from 'lucide-react';

const Team = () => {
  return (
    <div className="team-page pt-20">
      
      {/* =========================================
          HERO SECTION
          ========================================= */}
      <section className="py-24 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 
            className="page-title text-center mb-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold"
            style={{ color: '#C24D36' }}
          >
            Notre Équipe & Philosophie
          </h1>
          
          <p className="text-xl sm:text-2xl md:text-3xl text-center text-[#F9F6F0] max-w-6xl mx-auto font-bold">
            Rencontrez les passionnés qui donnent vie à Soul Kitchen chaque jour.
          </p>
        </div>
      </section>

      {/* =========================================
          TEAM SECTION (Design 1/3 Image - 2/3 Texte)
          ========================================= */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <h2 className="section-title text-center mb-8 text-4xl md:text-5xl">Notre Équipe</h2>
          
          <div className="flex flex-col gap-6 max-w-6xl mx-auto">
            {mockData.team.map((member, index) => {
              const isEven = index % 2 === 0;

              return (
                <div 
                  key={member.id} 
                  // GAP RÉDUIT : gap-6 pour que le texte soit proche de l'image
                  className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'} items-start gap-6`}
                >
                  
                  {/* --- BLOC IMAGE (1/3 de la largeur) --- */}
                  <div className="w-full md:w-1/3">
                    {/* - h-64 : Hauteur fixe
                        - w-full : Prend toute la largeur de son conteneur (qui fait 1/3)
                        - !isEven ? 'md:ml-auto' : '' -> Colle à droite si c'est une ligne impaire
                    */}
                    <div className={`overflow-hidden rounded-xl shadow-lg transform transition-transform duration-500 hover:scale-[1.02] h-64 w-full ${!isEven ? 'md:ml-auto' : ''}`}>
                      <img
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  {/* --- BLOC TEXTE (2/3 de la largeur) --- */}
                  <div className="w-full md:w-2/3 text-center md:text-left">
                    
                    <h3 
                      className="text-3xl font-bold mb-1 text-[#C24D36]" 
                      style={{ fontFamily: 'var(--font-serif)' }}
                    >
                      {member.name}
                    </h3>
                    
                    <p className="text-xl font-semibold text-[#5A6C45] mb-3 font-sans">
                      {member.role}
                    </p>

                    <div className="text-[#3E332E] text-justify font-sans leading-relaxed text-base">
                      {Array.isArray(member.description) ? (
                        member.description.map((paragraph, idx) => (
                          <p key={idx} className="mb-2 last:mb-0">
                            {paragraph}
                          </p>
                        ))
                      ) : (
                        <p>{member.description}</p>
                      )}
                    </div>
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* =========================================
          PHILOSOPHY SECTION
          ========================================= */}
      <section className="py-16 md:py-24 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            
            <div className="flex flex-col justify-center">
              <h2 className="section-title mb-6 text-4xl md:text-5xl">{mockData.philosophy.title}</h2>
              <p className="text-lg text-[#3E332E] mb-8 leading-relaxed">
                {mockData.philosophy.description}
              </p>
              <ul className="space-y-4">
                {mockData.philosophy.principles.map((principle, index) => (
                  <li key={index} className="flex items-start">
                    <CheckCircle className="w-6 h-6 text-[#C24D36] mr-3 flex-shrink-0 mt-0.5" />
                    <span className="text-[#3E332E] text-lg">{principle}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="relative rounded-lg overflow-hidden min-h-[300px] lg:min-h-0 shadow-xl"> 
              <img
                src={mockData.philosophy.image}
                alt="Notre philosophie"
                className="w-full h-full object-cover lg:absolute lg:inset-0 object-bottom"
              />
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          MISSION SECTION
          ========================================= */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="section-title mb-6 text-4xl md:text-5xl">Notre Mission</h2>
          
          <p className="text-[#3E332E] leading-relaxed text-base md:text-lg lg:text-xl font-medium">
            Sensibiliser et accompagner vers une alimentation plus saine, plus locale et plus respectueuse de l'environnement. 
            Nous croyons qu'une cuisine végétalienne de qualité peut nourrir des centaines de personnes tout en contribuant à un avenir durable.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Team;